import { useEffect } from 'react';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { useNotification } from 'hooks/ui/useNotification';
import { api } from 'lib/httpClient';
import { QUERY_STALE_TIME_MS } from 'further-ui/config';

type Params = {
  name: string;
};

export function useOrganisationAllowedDomains(params: Params) {
  const notification = useNotification();

  const fetchQuery = useQuery<{ allowedDomains: Array<string> }>({
    queryKey: ['organisation-allowed-domains', params],
    queryFn: async () => {
      const response = await api.get(`organisation/allowed-domains`, {
        params,
      });

      return response.data.data;
    },
    placeholderData: keepPreviousData,
    staleTime: QUERY_STALE_TIME_MS,
    refetchOnWindowFocus: false,
    enabled: !!params.name,
  });

  useEffect(() => {
    if (fetchQuery.isError) {
      notification.error(
        'Could not retrieve allowed domains for this organisation.',
      );
    }
  }, [fetchQuery.isError, notification]);

  return fetchQuery;
}
